<template>
  <v-row class="justify-center" no-gutters>
    <v-col lg="5" md="6" sm="8" cols="12">
      <notifications group="actions"></notifications>
      <v-card class="pa-3 pb-2 pt-2" elevation="5">
        <login></login>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import api from '../../api';
  import login from '../../components/Login/login'

  export default {
    name: 'Login',
    components: {
      login
    },
    mounted() {
      const token = this.$route.query.token
      if (token) {
        this.$store.dispatch('loginThroughToken', {token})
      }
      this.checkRedirect()
    },
    methods: {
      checkRedirect() {
        if (document.location.hostname.indexOf('1cvrg') === -1) {
          let companyName = window.location.hostname.split('.').slice(0, -2).join('.').trim().toLowerCase()
          let dst = window.location.host.split('.').slice(-2).join('.').trim().toLowerCase()
          // let companyName = this.$route.currentRoute.fullPath
          api.session.hasAccess({companyName}).then(undefined, (error) => {
            window.location.href = `https://${dst}`;
          })
        }
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/login/Login.vue